import { SUBCATEGORY_ALL } from '../../../../../services/transformers/osTargetingTransformer';

export const getUniqId = (id, osFamily) => (id === SUBCATEGORY_ALL ? `${osFamily}_${id}` : id);
